import { render, staticRenderFns } from "./TrGameV2.vue?vue&type=template&id=2aade6e4&scoped=true&"
import script from "./TrGameV2.vue?vue&type=script&lang=js&"
export * from "./TrGameV2.vue?vue&type=script&lang=js&"
import style0 from "./TrGameV2.vue?vue&type=style&index=0&id=2aade6e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aade6e4",
  null
  
)

export default component.exports